// extracted by mini-css-extract-plugin
module.exports = {"grey":"#b7b7bc","unow_orange":"#ffb10f"};